import { useEffect } from "react";
import interiorDecor from "../../assets/homepage/interiorDecor.jpeg";
import floorPlan from "../../assets/homepage/FloorPlan.jpeg";
import newProject4 from "../../assets/homepage/newProject4.jpeg";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

const services = [
  {
    to: "/featured-house-plans",
    img: floorPlan,
    alt: "Floor plan blueprint",
    title: "Building Plans",
    description:
      "As one of the leading architectural companies in Nigeria, we create building plans that stand the test of time.",
    aos: "fade-up",
    aosDelay: "0",
  },
  {
    to: "/construction",
    img: newProject4,
    alt: "Ongoing construction project",
    title: "Building Construction",
    description:
      "Complete construction solutions — from multi-residential estates to single-family homes. See our portfolio.",
    aos: "fade-up",
    aosDelay: "150",
  },
  {
    to: "/about",
    img: interiorDecor,
    alt: "Interior decoration showcase",
    title: "Interior Decor",
    description:
      "Our designers transform your home into a paradise with world-class finishing and state-of-the-art materials.",
    aos: "fade-up",
    aosDelay: "300",
  },
];

function Services() {
  useEffect(() => {
    AOS.init({ duration: 700, once: true });
  }, []);

  return (
    <section className="bg-gray-50 py-16 md:py-24 font-Montserrat">
      <div className="max-w-6xl mx-auto px-4 md:px-10">
        {/* Section header */}
        <div className="text-center mb-12">
          <p className="text-[#1877F2] uppercase tracking-[0.3em] text-xs md:text-sm font-semibold mb-3">
            What We Do
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3">
            Services We Offer
          </h2>
          <div className="w-12 h-1 bg-gradient-to-r from-[#1877F2] to-blue-400 rounded-full mx-auto mb-4" />
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            From architectural drawings to full construction — we handle every
            stage of bringing your home to life.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map(({ to, img, alt, title, description, aos, aosDelay }) => (
            <div
              key={title}
              className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group"
              data-aos={aos}
              data-aos-delay={aosDelay}
            >
              <Link to={to} className="block">
                <div className="overflow-hidden h-56 md:h-64">
                  <img
                    className="w-full h-full object-cover transition-transform duration-400 ease-in-out group-hover:scale-105"
                    alt={alt}
                    src={img}
                  />
                </div>
                <div className="p-6">
                  <div className="w-8 h-1 bg-[#1877F2] rounded-full mb-3" />
                  <h4 className="text-lg font-bold text-gray-900 mb-2">{title}</h4>
                  <p className="text-gray-500 text-sm leading-relaxed">{description}</p>
                  <span className="inline-block mt-4 text-[#1877F2] text-sm font-semibold group-hover:underline">
                    Learn more →
                  </span>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
